const drawerSelectors = {
  cartIconDesktop: document.querySelector('#cart-icon-desktop'),
  cartIconMobile: document.querySelector('#cart-icon-mobile'),
  cartTotal: document.querySelector('cart-form [data-cart-total]'),
  cartSave: document.querySelector('cart-form [data-cart-save]')
};

class AjaxCart extends HTMLElement {
    constructor() {
      super();
      this.cartForm = this.querySelector('form[data-cart-form]');
      this.cartDrawer = document.querySelector('#component-cart-drawer');
      this.sectionID = 'component-cart-drawer';

      if(window.globalSpace.template == 'cart'){
        this.sectionID = document.getElementById('cart--items').dataset.id;
        this.updateEvents();
      }else{
        this.getCartData();
      }

      this.cartForm.addEventListener('keydown', (e)=>{
        if (e.key === 'Enter' || e.keyCode === 13) {
            e.preventDefault();
        }
      });
      if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    }

    /**
     * Observe attribute of component
     * 
     * @returns {array} Attributes to Observe
     */
    static get observedAttributes() {
      return ['updating'];
    }

    /**
     * bind Other inside element events to DOM
     */
    updateEvents(){
      this.cartForm.querySelectorAll('[data-item-remove]').forEach(button => button.addEventListener('click', this.removeItem.bind(this)));
      this.cartForm.querySelectorAll('[data-qty-input]').forEach(button => button.addEventListener('change', (evt)=>{
        this.onQtyChange(evt);
      }));
    }
  
    /**
     * Open Cart drawer and add focus to drawer container
     */
    initCartDrawer(elementTofocus) {
      if(!window.globalSpace.cart_drawer){
        window.location.href = window.routes.cart_fetch_url || '/cart';
        return;
      }

      if(this.cartDrawer) this.cartDrawer.openDrawer(elementTofocus);
    }
  
     /**
     * Fetch latest cart data 
     */
     getCartData(){
      const cartRoute = `${window.location.pathname}?sections=${this.sectionID}`;
      fetch(cartRoute).then(response => response.json()).then(response => {
          this._updateCart(response);
      }).catch((e) => {
          console.error(e);
      }).finally(() => {
          // Cart HTML fetch done
      });
    }

    /**
     * Update cart HTML and Trigger Open Drawer event
     *
     * @param {string} cartHTML String formatted response from fetch cart.js call
     * @param {HTML Node} openDrawerBtn open drawer node
     */
    _updateCart(response, openDrawerBtn = null){
      if(response === null) return;
      
      this.setAttribute('updating', true);
      

      let cartHTML = response[this.sectionID] || response['template-cart'];
      const parser = new DOMParser();
      cartHTML = parser.parseFromString(cartHTML, 'text/html');

      const cartJSONEle = cartHTML.querySelector('[data-cartscriptjson]');
      if(cartJSONEle) window.globalSpace.cart = JSON.parse(cartJSONEle.textContent);

      const cartElement = cartHTML.querySelector('form');
      this.cartForm.innerHTML = cartElement.innerHTML;

      const cartTotal = Utility.formatMoney(window.globalSpace.cart.total_price, window.globalSpace.money_format);
      drawerSelectors.cartTotal.innerHTML = cartTotal;

      const cartItemsCount = cartHTML.querySelector('[data-item-count]');
      if(cartItemsCount) this.querySelector('[data-item-count]').innerHTML = cartItemsCount.innerHTML;

      const cartItemsCountHeader = cartHTML.querySelector('[data-item-count-header]');
      if(cartItemsCountHeader) this.querySelector('[data-item-count-header]').innerHTML = cartItemsCountHeader.innerHTML;

      const cartItemSave = cartHTML.querySelector('[data-cart-save]');
      if(cartItemSave && this.querySelector('[data-cart-save]')) this.querySelector('[data-cart-save]').innerHTML = cartItemSave.innerHTML;

      const cartFormContainer = this.querySelector('.cart-form-container');
      (window.globalSpace.cart.item_count <= 0) ? cartFormContainer.classList.add('empty_cart') : cartFormContainer.classList.remove('empty_cart');

      updateCartCountInHeader();

      this.updateEvents();

      window?.Shopify?.PaymentButton?.init();
      if(window.globalSpace.cart_drawer && openDrawerBtn){
        this.initCartDrawer(openDrawerBtn);
      }
      if(typeof customGWPJS == 'function') customGWPJS.prototype.cartGWP();
    }
  
     /**
     * Update Quantity API call 
     *
     * @param {string} line Line Index value of cart Item (Starts from 1)
     * @param {integer} quantity Quantity to update
     */
    updateItemQty(line, quantity){
      const lineItem = document.querySelectorAll('[data-cart-item]')[line-1];

      if(lineItem){ lineItem.classList.add('updating'); }
      const body = JSON.stringify({
        line,
        quantity,
        sections: `${this.sectionID}`
      });

      fetch(`${routes.cart_change_url}`, { ...Utility.fetchConfig(), ...{ body }})
      .then((response) => response.text())
      .then((_state) => {
        const dataJSON = ((typeof _state == 'object') ? _state : JSON.parse(_state));
        if(dataJSON.errors){
          window.notificationEle.updateNotification('Cart Update', dataJSON.errors, {
            type: 'error',
            timeout: 5000
          });

          const cartItem = window.globalSpace.cart.items[line-1];
          const qtyInput = this.cartForm.querySelector(`input[data-qty-input][data-index="${line}"]`);
          if(qtyInput) qtyInput.value = cartItem.quantity;
          return;
        }

        eventBus.publish(PUB_SUB_EVENTS.cartUpdate, {
          data: {
            action: (quantity == 0) ? 'remove-item': 'update-qty',
            item: (quantity == 0) ? dataJSON.items_removed : dataJSON.items_added
          }
        });
        this._updateCart(dataJSON.sections);
      }).catch((error) => {
        window.notificationEle.updateNotification('Cart Update', error, {
          type: 'error',
          timeout: 5000
        });
      }).finally(() => {
        setTimeout(() => {
          if(lineItem){ lineItem.classList.remove('updating'); }
        }, 500);
      });
    }
  
    /**
     * Remove Item Event
     */
    removeItem(event){
      event.preventDefault();
      const {currentTarget} = event;
      const itemIndex = currentTarget.dataset.index || null;
      if(itemIndex !== null){
          this.updateItemQty(itemIndex, 0);
      }
    }

    /**
     * Cart Item Qunatity Input change event
     */
    onQtyChange(evt){
      evt.preventDefault();
      const $qtyInput = evt.currentTarget;
      const qtyValue = $qtyInput.value;
      const itemIndex = $qtyInput.dataset.index || null;

      if(itemIndex) this.updateItemQty(itemIndex, qtyValue);
    }
}
customElements.define("cart-form", AjaxCart);